
import Iconify from '@/components/iconify';
import {
    InputAdornment,
    Stack,
    TextField, Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import CreateApiKeyDialog from './CreateApiKeyDialog';

CaktoApiTableSearch.propTypes = {
    searchTerm: PropTypes.string,
    setSearchTerm: PropTypes.func,
}

export default function CaktoApiTableSearch({ searchTerm, setSearchTerm }) {

    return (

        <Stack>
            <div className='flex flex-col gap-4 lg:flex-row lg:items-center justify-between'>
                <Typography variant="h6">
                    Chaves de API
                </Typography>

                <div className='flex flex-col lg:flex-row items-center gap-2'>
                    <TextField
                        className='w-full lg:w-max'
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        size='small'
                        placeholder='Pesquisar'
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <Iconify icon="ion:search-outline" />
                                </InputAdornment>
                            ),
                        }}
                    />

                    <CreateApiKeyDialog />
                </div>
            </div>
        </Stack>

    )
}